module.exports = __webpack_public_path__ + "img/seat_diagram.png";